// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__ZcNwL","modal":"Modal_modal__niM4J","titleCont":"Modal_titleCont__Zvz80","btnCont":"Modal_btnCont__00-46"};